import './NavList.css'

// Generic scrollable list area that fills the remaining nav column height.
function NavList({ children }) {
  return <div className="nav-list">{children}</div>
}

export default NavList
